import React from 'react';
import { PromptConfirmation, ValidationProps } from 'ui';
import { ExtraFooterButton } from 'ui/common/select/types';
import { STATE } from 'app/constants';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { useOptions } from 'app/components/options-handler/hooks';
import { SelectSingleHierarchy } from 'app/area/shared/translated-components';
import { LinkCodesTranslation } from '../constants';
import { usePromptOnChange } from '../hooks';

interface LinkCodesDetailsPickerProps {
  componentId: string;
  label: string;
  codetableId?: number;
  endpoint: string;

  shouldPrompt: boolean;

  valueItem: ComplexValue<number>;
  onChange: (value: ComplexValue<number>) => void;

  loadOptionsParams?: LoadOptions;
  optionsParams?: any;
  optionsRequestPayload?: any;

  searchRequired?: boolean;
  extraFooterButton?: ExtraFooterButton;
  translation: LinkCodesTranslation;
  validation?: ValidationProps;
}

export const LinkCodesDetailsPicker: React.FC<LinkCodesDetailsPickerProps> = ({
  componentId, label, codetableId, endpoint, shouldPrompt, valueItem, onChange,
  loadOptionsParams, optionsParams, optionsRequestPayload,
  searchRequired, extraFooterButton, translation, validation
}) => {

  const {
    options,
    fetching,
    loadOptions,
    onLoadOptions
  } = useOptions(STATE.linkCodes, componentId, endpoint, codetableId, {
    loadOptionsParams, optionsParams, optionsRequestPayload
  });

  const { displayPrompt, onPromptedChange, onContinue, onHide } = usePromptOnChange(shouldPrompt, onChange);

  return <>
    {shouldPrompt && displayPrompt && <PromptConfirmation
      title={translation.cancel_changes}
      description={translation.are_you_sure}
      continueText={translation.undo_all}
      cancelText={translation.go_back}
      onContinue={onContinue}
      onCancel={onHide} />}
    <div className="col-lg-6 col-sm-12">
      <SelectSingleHierarchy
        componentId={componentId}
        className={undefined}
        label={{ text: label }}
        valueItem={valueItem}
        descriptionAllLevels={true}
        onChange={onPromptedChange}

        searchRequired={searchRequired}
        extraFooterButton={extraFooterButton}

        options={options}
        fetching={fetching}
        loadOptions={loadOptions}
        onLoadOptions={onLoadOptions}

        placeholder={translation.search}
        validation={validation} />
    </div>
  </>;
};
